import React from 'react';
import ExperienceRiskBadge from './ExperienceRiskBadge';

const ExperienceRiskPanel = ({ records = [] }) => (
  <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
    <h3 className="text-sm font-semibold text-slate-100">Pengalaman Layanan Memburuk</h3>
    <div className="mt-3 space-y-2">
      {records.slice(0, 8).map((item) => (
        <div key={`risk-${item.customerId}`} className="rounded-lg border border-slate-800 bg-slate-950/60 p-2.5 text-xs text-slate-300">
          <div className="flex items-center justify-between gap-2">
            <div className="font-medium text-slate-100">{item.customerId} � {item.areaName || '-'}</div>
            <ExperienceRiskBadge level={item.experienceLevel} />
          </div>
          <div className="mt-1 text-slate-400">Issue: {item.primaryIssueType}</div>
          <div className="mt-1 text-slate-400">Rekomendasi: {item.recommendedAction}</div>
        </div>
      ))}
      {!records.length ? <div className="text-xs text-slate-500">Belum ada customer berisiko.</div> : null}
    </div>
  </section>
);

export default ExperienceRiskPanel;
